@defer (on viewport) {
  @if (languageChange$ | async; as _lang) {
    <ng-container *transloco="let t">
      <!--begin::User-->
      @if (profile$ | async; as _profile) {
        <div ngbDropdown display="dynamic">
          <!--begin::User info-->
          <button aria-label="Quick User Info" ngbDropdownToggle id="userQuickDropdown" class="btn btn-active-light d-flex align-items-center bg-hover-light py-2 px-2 px-md-3">
            <!--begin::Symbol-->
            <div class="symbol symbol-30px symbol-md-40px">
              <img [alt]="_profile?.user?.name + ' profile picture'" [title]="_profile?.user?.name + ' profile picture'" [src]="_profile?.user?.profile_image ? _profile?.user?.profile_image : _profile?.user?.gravatar" alt="image" />
            </div>
            <!--end::Symbol-->
            <!--begin::Name-->
            <div class="d-none d-md-flex flex-column align-items-start justify-content-center ms-2">
              @if (!_profile?.company?.name) {
                <span transloco="label_hello" class="text-muted fs-7 fw-semibold lh-1 mb-2"></span>
              }
              <span class="text-dark fs-base fw-semibold text-truncate mw-200px">{{ _profile?.user?.name }}</span>
              @if (_profile?.company?.id) {
                <span class="text-muted fs-7 fw-semibold lh-1 mt-2">
                  {{ _profile?.company?.name }}
                </span>
              }
            </div>
            <!--end::Name-->
          </button>
          <!--end::User info-->
          <!--begin::User account menu-->
          <div ngbDropdownMenu aria-labelledby="userQuickDropdown" class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-2 fs-6 w-275px">
            <!--begin::Menu item-->
            <div class="menu-item px-1">
              <div class="menu-content d-flex align-items-center px-2">
                <!--begin::Avatar-->
                <div class="symbol symbol-50px me-2">
                  <img [alt]="_profile?.user?.name + ' profile picture'" [title]="_profile?.user?.name + ' profile picture'" [src]="_profile?.user?.profile_image ? _profile?.user?.profile_image : _profile?.user?.gravatar" />
                </div>
                <!--end::Avatar-->
                <!--begin::Username-->
                <div class="d-flex flex-column">
                  <div class="fw-semibold d-flex align-items-center fs-6 text-truncate mw-200px">{{ _profile?.user?.name }}</div>
                  @if (_profile?.company?.id) {
                    <span class="fw-semibold text-muted fs-7 text-hover-primary">
                      {{ _profile?.company?.name }}
                    </span>
                  }
                  <span class="fw-semibold text-muted text-hover-primary fs-7"> {{ _profile?.user?.email }}</span>
                </div>
                <!--end::Username-->
              </div>
            </div>
            <!--end::Menu item-->
            <!--begin::Menu separator-->
            <div class="separator my-2"></div>
            <!--end::Menu separator-->
            <!--begin::Menu item-->
            <div class="menu-item px-3">
              <a [title]="t('label_dashboard')" [routerLink]="['/', _lang, 'account', 'start']" transloco="label_dashboard" class="menu-link px-5"></a>
            </div>
            <!--end::Menu item-->
            <!--begin::Menu item-->
            <div class="menu-item px-3">
              <a [title]="t('label_orders')" [routerLink]="['/', _lang, 'account', 'orders', 'subject', 'all']" transloco="label_orders" class="menu-link px-5"></a>
            </div>
            <!--end::Menu item-->
            <!--begin::Menu item-->
            <div class="menu-item px-3">
              <a [title]="t('label_questions')" [routerLink]="['/', _lang, 'account', 'inquiry']" transloco="label_questions" class="menu-link px-5"></a>
            </div>
            <!--end::Menu item-->
            <!--begin::Menu item-->
            <div class="menu-item px-3">
              <a [title]="t('label_profile')" [routerLink]="['/', _lang, 'account', 'profile']" transloco="label_profile" class="menu-link px-5"></a>
            </div>
            <!--end::Menu item-->
            <!--begin::Menu item-->
            @if (_profile?.company?.id && _profile?.company_access?.length; as _total) {
              @if (_total > 1) {
                <div class="menu-item px-3" ngbDropdown display="dynamic">
                  <a ngbDropdownToggle id="userAccessCompanyDropdown" class="menu-link text-hover-primary px-5 cursor-pointer">
                    <span class="menu-title text-hover-primary" transloco="label_your_companies"></span>
                    <span class="badge badge-light-primary">{{ _total }}</span>
                  </a>
                  <div ngbDropdownMenu aria-labelledby="userAccessCompanyDropdown" class="menu-sub menu-sub-dropdown py-4 mh-400px overflow-auto">
                    @for (company of _profile?.company_access; track company) {
                      <div [class.active]="company.id === _profile?.company?.id" (click)="onAccessCompany(company, _profile?.company?.name)" class="menu-item px-3">
                        <a href="javascript:;" class="menu-link text-hover-primary px-5 cursor-pointer" [class.active]="company.id === _profile?.company?.id">
                          {{ company.name }} &nbsp;
                          @if (company.id === _profile?.company?.id) {
                            <i class="fa fa-check text-primary"></i>
                          }
                        </a>
                      </div>
                    }
                  </div>
                </div>
              }
            }
            <!--end::Menu item-->
            <!--begin::Menu separator-->
            <div class="separator my-2"></div>
            <!--end::Menu separator-->
            <!--begin::Menu item-->
            <div class="menu-item px-3">
              <span (click)="logout()" transloco="label_sign_out" class="menu-link px-5"> </span>
            </div>
            <!--end::Menu item-->
          </div>
          <!--end::User account menu-->
        </div>
      } @else {
        <div (click)="logout()" class="btn btn-active-light d-flex align-items-center bg-hover-light py-2 px-2 px-md-3">
          <div class="symbol symbol-30px symbol-md-40px">
            <img title="Profile picture" src="./assets/media/avatars/user.png" alt="Profile picture" />
          </div>
          <div class="d-none d-md-flex flex-column align-items-end justify-content-center ms-2">
            <span class="text-muted fs-7 fw-bold lh-1 mb-2"></span>
            <span class="text-dark fs-base fw-semibold lh-1" transloco="label_sign_in"></span>
          </div>
        </div>
      }
      <!--end::User -->
    </ng-container>
  }
} @placeholder {
  <div class="btn btn-active-light d-flex align-items-center bg-hover-light py-2 px-2 px-md-3">
    <div class="symbol symbol-30px symbol-md-40px">
      <img title="Profile picture" src="./assets/media/avatars/user.png" alt="Profile picture" />
    </div>
    <div class="d-none d-md-flex flex-column justify-content-center ms-2 placeholder-glow">
      <span class="text-muted fs-9 fw-bold lh-1 mb-2 placeholder w-40px"></span>
      <span class="text-muted fs-9 fw-bold lh-1 placeholder w-30px"></span>
    </div>
  </div>
} @error {
  <p class="d-none">Failed to component</p>
}
